import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

import { fetchTickersFromApi } from "~api/client/fetchTickersFromApi";
import { RequestStatus } from "~types/lineup";
import type { Security } from "~types/types";

interface UseTickerDataProps {
    tickerId: string;
}

type TickerData = Pick<
    Security,
    "id" | "price" | "percentChange1Day" | "realTimeTickerDescription"
>;

interface UseTickerDataOutput {
    status: RequestStatus;
    tickerData?: TickerData;
    setTickerData: Dispatch<SetStateAction<TickerData | undefined>>;
}

export const useTickerData = ({
    tickerId,
}: UseTickerDataProps): UseTickerDataOutput => {
    const [tickerData, setTickerData] = useState<TickerData>();
    const [status, setStatus] = useState<UseTickerDataOutput["status"]>(
        RequestStatus.NotStarted
    );

    useEffect(() => {
        if (!tickerId) {
            return;
        }

        setStatus(RequestStatus.Pending);
        fetchTickersFromApi({ ids: [tickerId] })
            .then(([data]) => {
                setTickerData(data);
            })
            .catch((error) => {
                console.error(`Error occurred fetching ticker data: ${error}`);
            })
            .finally(() => {
                setStatus(RequestStatus.Done);
            });
    }, [tickerId]);

    return {
        tickerData,
        setTickerData,
        status,
    };
};
